/**
 * Dati reali del ristorante — centralizzati qui apposta: quando arrivano i
 * dati definitivi dal cliente, si aggiorna solo questo file.
 * Ogni valore marcato PLACEHOLDER è provvisorio, vedi requirements.md del progetto.
 */

const MAPS_QUERY = "Il Pozzo, Viale Antonio Allegri 7, Reggio Emilia";

export const site = {
  name: "Il Pozzo",
  tagline: "Ristorante Enoteca",
  address: {
    street: "Viale Antonio Allegri, 7",
    postalCode: "42121",
    city: "Reggio Emilia",
    province: "RE",
    country: "IT",
    mapsQuery: MAPS_QUERY,
    // Link a Google Maps (si apre solo se cliccato: nessuna richiesta a Google prima).
    mapsUrl: `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(MAPS_QUERY)}`,
  },
  // Numero definitivo comunicato dal cliente il 2026-10-14 (sostituisce lo
  // 0522 451300): un solo mobile per chiamate e WhatsApp prenotazioni.
  phoneDisplay: "+39 353 418 1145",
  phoneHref: "tel:+393534181145",
  whatsappNumber: "393534181145",
  // Confermato dal cliente il 2026-09-03 (sostituisce ilpozzo@libero.it).
  email: "ilpozzo@gmail.com",
  // ID flusso dati GA4 (pubblico per natura: finisce nel browser di chi accetta).
  // Fornito dal cliente il 2026-10-15. Caricato SOLO dopo consenso ai cookie,
  // vedi components/layout/google-analytics.tsx. Si può sovrascrivere con la
  // build variable NEXT_PUBLIC_GA_MEASUREMENT_ID (es. per un ambiente di test).
  gaMeasurementId: "G-JMFZFDGR26",
  instagram: {
    handle: "ilpozzoristorante_enoteca",
    url: "https://www.instagram.com/ilpozzoristorante_enoteca/",
  },
  // Confermato dal cliente il 2026-09-03. Chiuso lunedì e domenica
  // (giorni di apertura in messages/*.json, chiave common.hoursDays).
  hours: {
    lunch: "12:30 — 14:30",
    dinner: "19:45 — 23:00",
  },
  // Anno confermato dal titolare il 2026-09-18 (1888). Nomi famiglia/chef ancora PLACEHOLDER da verificare
  // (fonti: Accademia Italiana della Cucina, Michelin Guide).
  history: {
    since: 1888,
    family: "Davoli-Battistessa",
    chef: "Emanuele Pervilli",
  },
  // PLACEHOLDER — ripartizione coperti da confermare.
  seats: {
    indoor: 75,
    garden: 70,
  },
  // Confermati dal cliente il 2026-09-23. legalName verbatim come fornito
  // (nome legale registrato — non normalizzato/corretto di mia iniziativa).
  legalName: "Enoteca Ristorante il pozzo snc di Battistessa e Davoli",
  vatNumber: "01397650357",
  // Numero REA (Registro Imprese, CCIAA di Reggio Emilia) comunicato dal
  // cliente il 2026-10-16. Obbligatorio nelle comunicazioni d'impresa (art.
  // 2250 c.c.). Sigla provincia RE assunta dalla sede: da confermare.
  reaNumber: "RE-182376",
  // Codice destinatario SDI (fatturazione elettronica) — dato amministrativo,
  // non mostrato sul sito pubblico (non richiesto in Privacy Policy/footer,
  // serve solo a chi deve fatturare all'attività). Tenuto qui per un solo
  // punto di verità se servisse in futuro (es. modulo di fatturazione interno).
  sdiCode: "T04ZHR3",
} as const;
